import React, {useState, useRef, useEffect} from 'react'
import styled from 'styled-components'

import {information_data} from '../../data/aboutData'

export default () => {
  const [dotDistance, setDotDistance] = useState([])
  const refDot = useRef([])

  useEffect(() => {
    setTimeout(setLineLength, 100)
  }, [])

  const setLineLength = () => {
    const result = refDot.current.map((dot, index) => {
    if (index + 1 !== refDot.current.length) {
      const targetDot = refDot.current[index + 1]
      const currentFromTop = window.pageYOffset + dot.getBoundingClientRect().top
      const targetFromTop = window.pageYOffset + targetDot.getBoundingClientRect().top
      return targetFromTop - currentFromTop
    }
    }).filter((filter) => filter)
    setDotDistance(result)
  }

  return (
    <Container>
      <Name>
        MINWOO KIM
        <span>[RHAPSODIST]</span>
      </Name>
      <CurrentInfo>
        <WrapperBox>
          {
            information_data.bassInfo.map((info, index) => {
              
              return (
                <InfoItem key={info}>
                  <DotAndLine>
                    <Line height={dotDistance[index]} dotSize={dotSize}/>
                    <Dot ref={(el) => refDot.current[index] = el} dotSize={dotSize}/>
                  </DotAndLine>
                  <Info>{info}</Info>
                </InfoItem>
              )
            })
          }
        </WrapperBox>
      </CurrentInfo>
    </Container>
  )
}

const dotSize = 0.5

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  @media(min-width: 1300px) {
    position: initial;
    display: flex;
    padding: 3rem 0.5rem;
    width: 50%;
    flex-direction: column;
  }
`
const Name = styled.h2`
  font-family: DINMed;
  font-size: 2rem;
  position: absolute;
  right: 10%;
  top: 4rem;
  color: ${props => props.theme.darkBeige};
  z-index: 2;
  & span {
    display: block;
  }
  @media(min-width: 1100px) {
    top: 1rem;
    right: 17%;
  }
  @media(min-width: 1300px) {
    position: initial;
    display: flex;
  }
`
const CurrentInfo = styled.div`
  position: absolute;
  width: 100%;
  height: 55%;
  bottom: 0;
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media(min-width: 1100px) {
    align-items: flex-end;
    height: 80%;
  }
  @media(min-width: 1300px) {
    position: initial;
    align-items: flex-start;
    padding: 0;
  }
`
const WrapperBox = styled.div`
  display: inline-block;
  @media(min-width: 1100px) {
    padding: 0 3rem;
  }
  @media(min-width: 1300px) {
    padding: 0;
  }
`
const InfoItem = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding-bottom: 0.6rem;
`
const DotAndLine = styled.div`
  width: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 0.5rem;
`
const Line = styled.div`
  border-right: 1.2px solid ${props => props.theme.darkBeige};
  height: ${props => props.height}px;
  padding: 0;
  top: ${props => props.dotSize}rem;
  position: absolute;
`
const Dot = styled.div`
  width: ${props => props.dotSize}rem;
  height: ${props => props.dotSize}rem;
  background-color: ${props => props.theme.green};
  border: 1.5px solid ${props => props.theme.darkBeige};
  border-radius: 50%;
  z-index: 1;
`
const Info = styled.p`
  color: ${props => props.theme.darkBeige};
  font-family: DINReg;
  font-size: 1.2rem;
`